import { combineReducers } from 'redux';

import global from './global';
import authenticate from './authenticate';
import ticket from './ticket';

export default combineReducers({
  authenticate,
  global,
  ticket,
});
